import { Layout } from './layout';
import { drawRotatedLabel, crispifyPixel, BY_GENOME } from './common';
import { GENE_COLORS, UNIFORM_COLOR,
  LIGHT_LABEL, LIGHT_VARIANT_NAME_COLOR,
  DARK_LABEL, DARK_VARIANT_NAME_COLOR,
  VARIANT_FONT, MUTATION_FONT, BLOCK_FONT,
  SEQUENCE_TICK_STROKE_WEIGHT,
  HORIZ_BAND_WIDTH, HORIZ_BAND_MARGIN,
  DETAIL_BOX_TOP_GAP,
  TOP_MARGIN, MUTATION_LABEL_Y,
  LEFT_MARGIN, VARIANT_LABEL_XPOS, RIGHT_MARGIN, SEQ_MARGIN_HORIZ,
  MUT_MARGIN_HORIZ_BLOCK,
  MIN_WIDTH_FOR_LETTER, MARKER_HT_EXTRA, GENE_LABEL_WIDTH, MAX_BLOCK_WIDTH,
  TEXT_ANGLE, HIGHLIGHT_BORDER, GENE_MARKER_OFFSET } from './styles';


import { MutationArrangement } from './mutationarrangement';

export default class HorizontalLayout extends Layout {

  constructor() {
    super();
    this.unhideContainer = document.getElementById('hidden-region-list');
    this.unhideItemTemplate = this.unhideContainer.querySelector('li');
    this.unhideContainer.innerHTML = '';
    this.regionContainer = document.getElementById('block-region-names');
    this.regionNameTemplate = this.regionContainer.querySelector('.region-label');
    this.regionContainer.innerHTML = '';
    this.geneMarkers = {};
  }



  positionBySequence() {
    let {geneWedges, variants, W} = this;
    if (!variants || !variants.length) return;
    this.regionContainer.innerHTML = '';
    this.geneMarkers = {};
    this.geneMargin = SEQ_MARGIN_HORIZ;
    let markerHeight = variants.length * HORIZ_BAND_WIDTH + HORIZ_BAND_MARGIN * (variants.length - 1);

    let arrangement = new MutationArrangement(this.geneWedges, this.currentMutations);
    arrangement.arrangeByPosition();
    let {genes, labelList} = arrangement;
    let sequenceMargin = SEQ_MARGIN_HORIZ,
      regionCount = Object.keys(genes).length,
      bandWidth = W - LEFT_MARGIN - RIGHT_MARGIN - sequenceMargin * (regionCount - 1),
      mutCount = geneWedges.filter(gw=>gw.shown).reduce((tot,gw)=>tot+gw.aaCount, 0);

    this.lineWidth = SEQUENCE_TICK_STROKE_WEIGHT;
    let mutLookup = {},
      left = crispifyPixel(LEFT_MARGIN);
    geneWedges.forEach((gw)=>{
      let geneData = genes[gw.name];
      if (!geneData) {
        gw.setXpositions(left, 0);
      } else {
        let {aaCount} = gw,
          width = Math.round(aaCount / mutCount * bandWidth),
          x = crispifyPixel(left),
          labels = genes[gw.name].labels;
        geneData.x = left;
        geneData.width = width;
        this.addGeneMarker(gw, x, markerHeight);
        gw.setXpositions(x, width);
        gw.visibles.forEach(item=>{
          let mutation = item.mutation,
            position = mutation.position,
            label = labels[position];
          item.x = gw.getX(mutation);
          mutLookup[mutation.name] = item;
          label.setX(item.x, SEQUENCE_TICK_STROKE_WEIGHT);
          /*
          if there is only one item at this position
          change the label text to the full mutation name
          */
          label.reviseText();
          label.deemphasize(item.deemphasized);
        });
        left += width + sequenceMargin;
      }
    });
    this.setVariantPositions(mutLookup, genes, arrangement.labelList, false);
    this.geneLabels = genes;
    this.labelList = labelList;
  }

  positionByMutationName(allowWildTypeOverride) {
    if (this.geneWedges) {
      let arrangement = new MutationArrangement(this.geneWedges, this.currentMutations);
      arrangement.arrangeByName();
      let {genes, labelList} = arrangement;
      this.positionMutationsImpl(genes, labelList, allowWildTypeOverride);
    }
  }


  positionByMutationLocation() {
    if (this.geneWedges) {
      let arrangement = new MutationArrangement(this.geneWedges, this.currentMutations);
      arrangement.arrangeByPosition();
      let {genes, labelList} = arrangement;
      this.positionMutationsImpl(genes, labelList);
    }
  }




  setVariantPositions(mutLookup, genes, labelList, allowWildTypeOverride) {
    let {variants, threshold} = this;
    let top = TOP_MARGIN,
      markerHeight = variants.length * HORIZ_BAND_WIDTH + HORIZ_BAND_MARGIN * (variants.length - 1);
    this.labelY1 = TOP_MARGIN;
    this.labelY2 = TOP_MARGIN + markerHeight + DETAIL_BOX_TOP_GAP;
    this.mutationLabelY = MUTATION_LABEL_Y;
    variants.forEach((variant)=>{
      variant.setMutationPositionsHorizontal(mutLookup, genes, labelList, threshold,
        top, HORIZ_BAND_WIDTH, this.lineWidth, this.bySequence, allowWildTypeOverride);
      top += HORIZ_BAND_WIDTH + HORIZ_BAND_MARGIN;
    });
  }


  addGeneMarker(gw, x1, markerHeight) {
    let nameDiv = this.regionNameTemplate.cloneNode(true),
      border = nameDiv.querySelector('.region-border'),
      left = Math.floor(x1) + GENE_MARKER_OFFSET;
    nameDiv.querySelector('.region-name').innerText = gw.shortLabel;
    nameDiv.querySelector('.region-remove').classList.add(`reg--${  gw.shortLabel}`);
    nameDiv.style.left = `${left}px`;
    border.style.height = `${Math.ceil(markerHeight) + MARKER_HT_EXTRA}px`;
    nameDiv.style.color = this.darkMode ? GENE_COLORS[gw.name][`light_color_${UNIFORM_COLOR}`] : GENE_COLORS[gw.name][`dark_color_${UNIFORM_COLOR}`];
    nameDiv.querySelector('.region-remove').addEventListener('click', ()=>{
      gw.setShown(false);
      let item = this.unhideItemTemplate.cloneNode(true),
        nameSpan = item.querySelector('.hidden-region-name'),
        addSpan = item.querySelector('.hidden-region-add');
      nameSpan.innerText = gw.label;
      nameSpan.style.color = GENE_COLORS[gw.name].light_color_4;
      addSpan.style.backgroundColor = GENE_COLORS[gw.name].light_color_4;
      this.unhideContainer.appendChild(item);
      this.unhideContainer.parentNode.classList.remove('empty');
      item.addEventListener('click', ()=>{
        gw.setShown(true);
        item.remove();
        if (this.unhideContainer.children.length === 0) {
          this.unhideContainer.parentNode.classList.add('empty');
        }
      });
    });
    this.regionContainer.appendChild(nameDiv);
    this.geneMarkers[gw.name] = {div : nameDiv, x: left};
  }



  positionMutationsImpl(genes, labelList, allowWildTypeOverride){
    let {geneWedges, variants} = this;
    if (!variants || !variants.length) return;
    this.regionContainer.innerHTML = '';
    this.geneMarkers = {};
    this.geneMargin = MUT_MARGIN_HORIZ_BLOCK;
    let markerHeight = variants.length * HORIZ_BAND_WIDTH + HORIZ_BAND_MARGIN * (variants.length - 1);

    let spacePerMutation = this.assignEvenSpacingX(genes, labelList, MUT_MARGIN_HORIZ_BLOCK);

    this.lineWidth = Math.floor(spacePerMutation-2);
    let mutLookup = {},
      left = LEFT_MARGIN;
    geneWedges.forEach((gw)=>{
      let geneData = genes[gw.name];
      if (!geneData) {
        gw.setXpositions(left, 0);
      } else {
        let {x, width, labels} = geneData;
        this.addGeneMarker(gw, x, markerHeight);
        gw.setXpositions(x, width);
        Object.values(labels).forEach(({items})=>{
          items.forEach(item=>mutLookup[item.mutation.name] = item);
        });
        left = x;
      }
    });
    this.setVariantPositions(mutLookup, genes, labelList, allowWildTypeOverride);
    this.geneLabels = genes;
    this.labelList = labelList;
  }




  assignEvenSpacingX(genes, labelList, geneMargin) {
    let { W } = this;
    /*
    work out how to calculate the size of each mutation when:
      mutations are grouped by gene
      each gene has a minimum size
      there is a margin between genes
      genes with no mutations do not get shown
    */
    let countBasis = labelList.length,
      genesWMutations = Object.keys(genes),
      bandWidth = W - LEFT_MARGIN - RIGHT_MARGIN,
      calcLength = bandWidth - (genesWMutations.length - 1) * geneMargin,
      spacePerMutation = Math.min(MAX_BLOCK_WIDTH, calcLength / countBasis),
      widths = {};
    countBasis = 0;
    /*
    identify the genes where the label is wider than the space
    taken up to draw the mutations. Set their width equal to
    the gene label and remove them from the available space.
    If the mutations get wider than the gene, tally them.
    */
    Object.keys(genes).forEach(name=>{
      let arr = Object.keys(genes[name].labels),
        c = arr.length,
        w = c * spacePerMutation;
      if (w < GENE_LABEL_WIDTH) {
        widths[name] = GENE_LABEL_WIDTH;
        calcLength -= GENE_LABEL_WIDTH;
      } else {
        countBasis += c;
      }
    });
    /*
    now set the space required for the genes
    where the mutations are wider than the gene label
    */
    spacePerMutation = Math.min(MAX_BLOCK_WIDTH, calcLength / countBasis);
    let lineWidth = Math.floor(spacePerMutation-1),
      halfLine = lineWidth / 2,
      left = crispifyPixel(LEFT_MARGIN + halfLine);
    Object.keys(genes).forEach(name=>{
      let geneData = genes[name],
        labels = genes[name].labels,
        arr = Object.keys(labels),
        count = arr.length,
        width = count * spacePerMutation;
      if (!widths[name]) {
        widths[name] = width;
      }
      geneData.x = left;
      geneData.width = width;
      arr.sort((a,b)=>parseInt(a)-parseInt(b));
      arr.forEach((pos, index)=>{
        let x = crispifyPixel(left + halfLine + index / count * width),
          x2 = crispifyPixel(left + halfLine + (index + 1) / count * width),
          w = x2 -x;
        labels[pos].setX(x, w);
      });
      left += width + geneMargin;
    });
    return spacePerMutation;
  }

  setMutationIndex(i) {
    if (i !== this.highlightIndex) {
      this.highlightIndex = i;
      if (this.labelList) {
        let geneMarkers = this.geneMarkers;
        if (i === undefined) {
          this.labelList.forEach(l=>{
            l.goHome();
            l.hideBorder();
          });
          this.geneWedges.forEach(gw=>{
            gw.adjustX(0);
            gw.adjustW(0);
          });
          Object.values(geneMarkers).forEach(({div, x})=>div.style.left = `${x}px`);
        } else {
          let processedGenes = {},
            wedgeLookup = {},
            offset = HIGHLIGHT_BORDER;
          if (this.bySequence === BY_GENOME) {
            offset += MIN_WIDTH_FOR_LETTER;
          }
          this.geneWedges.forEach(gw=>wedgeLookup[gw.name] = gw);
          this.labelList.forEach((l, index)=>{
            let gene = l.gene,
              processed = geneMarkers[gene] && processedGenes[gene] !== undefined;
            if (index < i) {
              l.adjustX(-offset);
              l.fade();
              l.hideBorder();
            } else if (index > i) {
              l.adjustX(offset);
              l.fade();
              l.hideBorder();
            } else {
              l.goHome();
              l.showBorder();
              wedgeLookup[gene].adjustW(offset * 2);
            }
            if (!processed) {
              let adjX = index < i ? -offset
                  : index > i ? offset
                    : this.bySequence === BY_GENOME ? -offset : 0,
                adjW = index === i ? offset * 2 : 0;
              let {div, x} = geneMarkers[gene],
                gw = wedgeLookup[gene];
              gw.adjustX(adjX);
              gw.adjustW(adjW);
              div.style.left = `${x + adjX}px`;
              processedGenes[gene] = true;
            }
          })
        }
      }
    }
  }

  draw(ctx) {
    let {variants, bySequence, darkMode, W, H,
      labelY1, labelY2, mutationLabelY, highlightMutation} = this;

    if (!variants || !variants.length) return;
    // let st = Date.now();
    ctx.clearRect(0, 0, W, H);
    this.drawBars(ctx, darkMode, highlightMutation, bySequence);
    this.drawVariantMutations(ctx, highlightMutation);
    this.drawVariantNames(ctx, darkMode);
    this.drawLabels(ctx, highlightMutation, darkMode, labelY1, labelY2, bySequence, mutationLabelY);

  }


  drawBars(ctx, darkMode, highlightMutation, bySequence) {
    if (this.bySequence === BY_GENOME) {
      this.geneWedges.forEach(gw=>{
        if (gw.shown) {
          let highlightGene = highlightMutation ? highlightMutation[0].mutation.gene : '';
          this.variants.forEach(variant=>{
            variant.drawGeneBar(ctx, bySequence, darkMode, highlightGene, gw);
          });
        }
      });
    }
  }


  drawVariantMutations(ctx) {
    ctx.lineWidth = this.lineWidth;
    this.variants.forEach(variant=>{
      variant.drawMutationsHorizontal(ctx);
    });
    if (this.bySequence !== BY_GENOME && this.lineWidth >= MIN_WIDTH_FOR_LETTER) {
      let textAlign = ctx.textAlign;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'white';
      ctx.font = BLOCK_FONT;
      this.variants.forEach(variant=>{
        variant.drawSubstitutionLetters(ctx);
      });
      ctx.textAlign = textAlign;
    } else if (this.highlightMutation) {
      let textAlign = ctx.textAlign;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'white';
      ctx.font = BLOCK_FONT;
      this.variants.forEach(variant=>{
        variant.drawHighlightLetter(ctx, this.highlightIndex);
      });
      ctx.textAlign = textAlign;
    }
  }

  drawLabels(ctx, highlightMutation, darkMode, labelY1, labelY2, bySequence, mutationLabelY) {
    let baseline = ctx.textBaseline,
      highlighting = !!highlightMutation,
      defaultAlpha = highlighting ? 0.5 : 1;
    ctx.fillStyle = darkMode ? DARK_LABEL : LIGHT_LABEL;
    ctx.textBaseline = 'middle';
    ctx.font = MUTATION_FONT;
    if (bySequence === BY_GENOME) {
      if (highlighting) {
        let geneName = highlightMutation[0].mutation.gene,
          geneData = this.geneLabels[geneName];
        if (geneData) {
          let {labels} = geneData,
            labelInfo = labels[highlightMutation[0].mutation.position];
          drawRotatedLabel(ctx, labelInfo.text, labelInfo.x, mutationLabelY, TEXT_ANGLE);
        }
      } else {
        let prevX = -100;
        const MIN_DIST = 10;
        ctx.strokeStyle =  darkMode ? DARK_LABEL : LIGHT_LABEL;
        ctx.lineWidth = 0.25;
        ctx.globalAlpha = defaultAlpha;
        ctx.beginPath();
        this.geneWedges.forEach(gw=>{
          let geneData = this.geneLabels[gw.name];
          if (geneData) {
            let {labels} = geneData;
            Object.values(labels).forEach(({text, x, deemphasized})=>{
              if (!deemphasized) {
                ctx.moveTo(x,mutationLabelY + 4);
                ctx.lineTo(x,mutationLabelY + 9);
                if (x - prevX >= MIN_DIST) {
                  prevX = x;
                  drawRotatedLabel(ctx, text, x, mutationLabelY, TEXT_ANGLE);
                }
              }
            });
          }
        });
        ctx.stroke();
      }
    } else {
      this.labelList.forEach(l=>{
        l.draw(ctx, mutationLabelY);
      })
    }
    ctx.textBaseline = baseline;
  }


  drawVariantNames(ctx, darkMode) {
    let textX = VARIANT_LABEL_XPOS;//LEFT_MARGIN - 15;
    ctx.font = VARIANT_FONT;
    ctx.fillStyle = darkMode?  DARK_VARIANT_NAME_COLOR : LIGHT_VARIANT_NAME_COLOR;
    ctx.textAlign = 'right';
    this.variants.forEach(variant=>{
      ctx.fillText(variant.label, textX, (variant.y1 + variant.y2) / 2 + 4);
    });
    ctx.textAlign = 'left';
  }






  getMutationAt(mx, my) {
    let {labelY1, labelY2, labelList} = this;
    let hgene = null,
      hpos = -1,
      hmut = null,
      hx = -1,
      hindex = -1;
    if (my >= labelY1 && my <= labelY2) {
      let mutations = labelList,
        closest = null,
        minD = 50,
        mIndex = -1;
      mutations.forEach((m, i)=>{
        let d = Math.abs(m.x - mx);
        if (d < minD) {
          closest = m;
          minD = d;
          mIndex = i;
        }
      })
      if (closest) {
        let first = closest.items[0].mutation;
        hgene = first.gene;
        hpos = first.position;
        hmut = closest.items;
        hx = closest.x;
        hindex = mIndex;
      }
    }
    return {hgene, hpos, hmut, hx, hindex};
  }

  getMutationX(mutationName) {
    let x = this.cx;
    this.geneWedges.forEach(gw=>{
      let match = gw.visibles.filter(m=>m.mutation.name === mutationName)[0];
      if (match) {
        x = match.x;
      }
    });
    return x;
  }
}


